<template>
  <div class="axes-figuration">
    <violet-bar>Affichage (ou non) des axes</violet-bar>
    <div class="box squarebox" v-if="axes_map">
      <div class="tags">
        <div class="tag" :key="axe.id" v-for="axe in axes">
          <input
            type="checkbox"
            class="checkbox"
            v-model="axes_map[axe.id]"
          />&nbsp;{{ axe.name }}
        </div>
      </div>
    </div>
    <div
      class="button button is-primary"
      :class="{ 'is-loading': loading }"
      @click="save"
    >
      Enregistrer
    </div>
  </div>
</template>
<script>
import VioletBar from "../Projects/VioletBar";
import { types } from "../../store/actions/kv";
import { types as ltypes } from "../../store/actions/misc";

export default {
  name: "axes_figuration",
  components: { VioletBar },
  data() {
    return {
      loading: false,
      axes: [],
      axes_map: null
    };
  },
  methods: {
    async fetch() {
      this.axes = await this.$store.dispatch(types.GET_KV, "axes");
      try {
        this.axes_map = await this.$store.dispatch(ltypes.GET_AXES);
      } catch (e) {
        this.axes_map = this.axes
          .map(a => a.id)
          .reduce((out, id) => {
            out[id] = false;
            return out;
          }, {});
      }
    },
    async save() {
      this.loading = 1;
      await this.$store.dispatch(ltypes.SET_AXES, this.axes_map);
      this.loading = 0;
    },
    is_axe_checked(id) {
      return typeof this.axes_map[id] !== "undefined" && this.axes_map[id];
    },
    handle_axe_check(id) {
      const val = this.is_axe_checked(id);
      this.axes_map[id] = !val;
    }
  },
  mounted() {
    this.fetch();
  }
};
</script>
